import { getDataFromPocket } from '../../utils/pocket';
import type { UserInfo } from './utils-pocket-models';

export function getClientIpSource(): 'internal' | 'external' {
    const clientInfo = getDataFromPocket<UserInfo>('clientinfo');

    switch (clientInfo?.ipSource) {
        case 'internal':
        case 'external':
            return clientInfo.ipSource;
        default:
            return 'external';
    }
}

export function getClientJA3(): string {
    const clientInfo = getDataFromPocket<UserInfo>('clientinfo');

    if (!clientInfo) {
        return '';
    }

    switch (clientInfo.ja3) {
        case '%%CLIENT_JA3%%':
            return '';
        default:
            return clientInfo.ja3;
    }
}

export function getClientJA4(): string {
    const clientInfo = getDataFromPocket<UserInfo>('clientinfo');

    if (!clientInfo) {
        return '';
    }

    switch (clientInfo.ja4) {
        case '%%CLIENT_JA4%%':
            return '';
        default:
            return clientInfo.ja4;
    }
}
